/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import url from "web/script/utils/url";
import store from "web/redux/store";
import { openSidebar } from "web/redux/ducks/feed-sidebar";

const ACTIONS = {
    newest: "SORT_BY_NEWEST",
    price_desc: "SORT_BY_HIGH_LOW",
    price_asc: "SORT_BY_LOW_HIGH",
    recommended: "SORT_BY_RECOMMENDED"
};

// register our component
export default baustein.register("filter-button", {
    setupEvents(add) {
        add("click", ".filter-button__filter-input", this.onFilter);
        add("change", ".filter-button__sort-select", this._onSort);
    },

    onFilter() {
        this.emit("openFilters");
        store.dispatch(openSidebar());
    },

    _onSort() {
        const value = this.el.querySelector("[sort-dropdown]").value;

        const sortOption = url.parse(value).searchParams.get("view");

        // add analytics
        const action = ACTIONS[sortOption];
        analytics.event("SORT_BY", action);

        this.emit("feedSortingChanged", { sortOption });
    }
});

